import { updateDeepState } from '../../../handlers'
import { DISPLAY_TOPIC_SUMMARY_INFO, UPDATE_TOPIC_SUMMARY_INFO } from '../../../types/conversations/plugins'

const initialTopicSummaryState = {
  isOpen: false,
  isLoading: false,
  topics: [],
}


export default function topicSummary(state = updateDeepState(initialTopicSummaryState), action) {
  switch (action.type) {
    case DISPLAY_TOPIC_SUMMARY_INFO: {
      const { isOpen, isLoading } = action
      return Object.assign({}, state, { isOpen, isLoading })
    }
    case UPDATE_TOPIC_SUMMARY_INFO: {
      const { topics } = action
      return Object.assign({}, state, { isLoading: false, topics })
    }
    default: {
      return state
    }
  }
}
